<template>
  <div class="process-dots clearfix">
    <span class="process-dot" v-for="(item, index) in length" :key="index"></span>
  </div>
</template>

<script>
export default {
  props: {
    length: [Number]
  }
};
</script>

<style lang="postcss" scoped>
.process-dot {
  float: left;
  width: 6px;
  height: 6px;
  margin-right: 10px;
  border-radius: 7px;
  background: #DDDDDD;
}
</style>



// WEBPACK FOOTER //
// src/projects/hsbpc/components/process-dots/index.vue